/**
 * CPB ID連携登録機能
 */

// 定数の重複宣言を防ぐ
if (typeof window.STAGING_ID_LINK_URL === "undefined") {
  window.STAGING_ID_LINK_URL =
    "https://development.cledepeau-beaute.com/jp/connect?token_data=";
  window.PRODUCTION_ID_LINK_URL =
    "https://www.cledepeau-beaute.com/jp/connect?token_data=";
}

async function fetchLinkStatusApi() {
  const shopUrl = window.location.origin;
  const proxyUrl = shopUrl + "/apps/cpb/id-link-inquiry";
  try {
    const response = await fetch(proxyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // レスポンスステータスをチェック
    if (!response.ok) {
      console.error("API Error:", response.status, response.statusText);
      return { success: false, error: `HTTP ${response.status}` };
    }

    // Content-Typeをチェック
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      console.error("Invalid content type:", contentType);
      return { success: false, error: "Invalid response format" };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch Error:", error);
    return { success: false, error: error.message };
  }
}

/**
 * 登録ボタンクリック時の処理
 */
async function handleLinkRegistration(event) {
  // デフォルトのリンク動作を防ぐ
  if (event) {
    event.preventDefault();
  }

  const shopUrl = window.location.origin;

  // 連携済みの場合、何もしないで処理を終了
  const linkStatus = await fetchLinkStatusApi();

  const isLinked =
    linkStatus &&
    linkStatus.success &&
    (linkStatus.status === "1" || linkStatus.status === "2");
  if (isLinked) {
    return;
  }

  const button = event
    ? event.target
    : document.querySelector(".cpb-id-link-button a");
  const originalText = button.textContent;

  // ボタンがすでに非活性なら何もしない
  if (button.classList.contains("is-disabled")) {
    return;
  }

  try {
    // ボタンを無効化して処理中表示
    button.classList.add("is-disabled");
    button.textContent = "処理中...";

    // ワンタイムパスワードAPI
    const otpUrl = shopUrl + "/apps/cpb/onetime-password";

    const response = await fetch(otpUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (data && data.success && data.onetime_password) {
      // 別タブでURLを開く
      // onetime_passwordがオブジェクトの場合はonetime_passwordプロパティを取得
      const passwordValue =
        typeof data.onetime_password === "string"
          ? data.onetime_password
          : data.onetime_password.onetime_password || data.onetime_password;
      const encodedPassword = encodeURIComponent(passwordValue);
      const idLinkUrl = window.PRODUCTION_ID_LINK_URL + encodedPassword;
      window.open(idLinkUrl, "_blank", "noopener");
    } else {
      throw new Error("ワンタイムパスワードの生成に失敗しました");
    }
  } catch (error) {
    console.error("登録処理エラー:", error);
    alert(
      "連携URLの取得に失敗しました。しばらく時間をおいて再度お試しください。"
    );
  } finally {
    // ボタンを元に戻す
    button.style.pointerEvents = "auto";
    button.textContent = originalText;
  }
}

async function checkCpbIdLinkStatus() {
  try {
    // 全てのCPB ID連携セクションを取得
    const sections = document.querySelectorAll(".cbp_status");

    // APIを1回だけ呼び出す
    const linkStatus = await fetchLinkStatusApi();

    for (const section of sections) {
      const loadingElement = section.querySelector(".cpb-id-loading");
      const notLinkedElement = section.querySelector(".cpb-id-not-linked");
      const registeringElement = section.querySelector(".cpb-id-registering");
      const linkedElement = section.querySelector(".cpb-id-linked");
      const errorElement = section.querySelector(".cpb-id-error");
      const linkButtonElement = section.querySelector(".cpb-id-link-button");
      const button = linkButtonElement.querySelector("a");

      if (
        !loadingElement ||
        !notLinkedElement ||
        !registeringElement ||
        !linkedElement ||
        !errorElement ||
        !linkButtonElement
      )
        if (!button) continue;

      // ローディング表示を非表示
      loadingElement.classList.add("content-hidden");

      if (linkStatus && linkStatus.success) {
        if (linkStatus.status !== undefined) {
          switch (linkStatus.status) {
            case "0": // 未連携
              notLinkedElement.classList.remove("content-hidden");
              linkButtonElement.classList.remove("content-hidden");
              break;
            case "1": // 登録中
              registeringElement.classList.remove("content-hidden");
              linkButtonElement.classList.remove("content-hidden");
              button.classList.add("is-disabled");
              break;
            case "2": // 連携済み
              linkedElement.classList.remove("content-hidden");
              linkButtonElement.classList.remove("content-hidden");
              button.classList.add("is-disabled");
              break;
            default:
              // 不明なステータスの場合は未連携として扱う
              notLinkedElement.classList.remove("content-hidden");
              linkButtonElement.classList.remove("content-hidden");
              button.classList.add("is-disabled");
          }
        } else {
          // statusフィールドが存在しない場合は未連携として扱う
          console.log(
            "Status field not found in API response, treating as not linked"
          );
          notLinkedElement.classList.remove("content-hidden");
          linkButtonElement.classList.remove("content-hidden");
          button.classList.add("is-disabled");
        }
      } else {
        // エラーまたはデータが取得できない場合はエラー表示
        errorElement.classList.remove("content-hidden");
        linkButtonElement.classList.remove("content-hidden");
      }
    }
  } catch (error) {
    console.error("Error in checkCpbIdLinkStatus:", error);
  }
}

// ページ読み込み時に自動実行（重複を防ぐ）
if (!window.cpbIdLinkInitialized) {
  document.addEventListener("DOMContentLoaded", function () {
    if (!window.cpbIdLinkInitialized && !window.cpbIdLinkStatusCompleted) {
      window.cpbIdLinkInitialized = true;
      checkCpbIdLinkStatus();
    }
  });
}

// グローバルに公開（重複を防ぐ）
if (typeof window.handleLinkRegistration === "undefined") {
  window.handleLinkRegistration = handleLinkRegistration;
}
if (typeof window.checkCpbIdLinkStatus === "undefined") {
  window.checkCpbIdLinkStatus = checkCpbIdLinkStatus;
}
